import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=ceb70af6&"
import script from "./ViewUser.vue?vue&type=script&lang=ts&"
export * from "./ViewUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports